import React,{ Component } from 'react';

import TutorialLoadingScreen from '../../../shared/components/TutorialLoadingScreen';

import { delayPromiseChain } from '../../../shared/utils';

class OnboardingTutorialSetup extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null
    };
  }


  componentDidMount(){
    this.props.createBrand({
      agencyId:this.props.activeUser.agencyId,
      name:this.props.activeAgency.name,
      isBrand:true,
      active:true,
    })
      .then((res) => this.props.createCampaign({
        name:'',
        agencyId:this.props.activeAgency.id,
        companyId:res.instance.id,
      }))
      .then((res) => delayPromiseChain(1000,res))
      .then((res) => {
        const campaignId = res.instance.id;
        this.props.history.push(`/welcome/tutorial/${campaignId}/create`)
      })
      .catch((err) => this.setState({error:err}));
  }

  render(){
    return (
      <TutorialLoadingScreen
        title="Let's build an experience together!"
        subtitle=''
        showSpinner
      />
    );
  }
}

export default OnboardingTutorialSetup;



// WEBPACK FOOTER //
// ./src/routes/OnboardingTutorialSetup/components/OnboardingTutorialSetup.js